import { ofType } from 'redux-observable'
import { EventResponseAction, ServerMessageType, EntitySnapshotEndAction, EventResponseStatus, SpreadsheetUploadIdentifier } from 'api'
import { BTQAction } from 'epics'
import { switchMap, map, filter, take, Observable, catchError, of, startWith, exhaustMap, timeout, merge } from 'rxjs'
import { SpreadsheetUploadActions, SpreadsheetUploadActionTypes } from './spreadsheetUploadActions'

export const mteUploadDealLoadingEpic = (action$: Observable<BTQAction>) =>
  action$.pipe(
    ofType<BTQAction, SpreadsheetUploadActionTypes.MTE_DEALS_UPLOADED_ACTION, ReturnType<typeof SpreadsheetUploadActions.mteDealsUploaded>>(
      SpreadsheetUploadActionTypes.MTE_DEALS_UPLOADED_ACTION
    ),
    switchMap(uploadedAction =>
      merge(
        of(SpreadsheetUploadActions.mteUploadDealsSubscribe(uploadedAction.payload.tradeIds, uploadedAction.payload.correlationId)),
        action$.pipe(
          startWith(uploadedAction),
          exhaustMap(a =>
            action$.pipe(
              startWith(a),
              ofType<BTQAction, ServerMessageType.EVENT_RESPONSE, EventResponseAction>(ServerMessageType.EVENT_RESPONSE),
              filter(
                action =>
                  action.payload.correlationId === uploadedAction.payload.correlationId &&
                  action.payload.status === EventResponseStatus.SUCCEEDED
              ),
              take(1)
            )
          ),
          exhaustMap(a =>
            action$.pipe(
              startWith(a),
              ofType<BTQAction, ServerMessageType.ENTITY_SNAPSHOT_END, EntitySnapshotEndAction>(ServerMessageType.ENTITY_SNAPSHOT_END),
              filter(({ payload }) => payload.subscriptionIds.includes(SpreadsheetUploadIdentifier.MTE_UPLOAD)),
              take(1)
            )
          ),
          map(() => SpreadsheetUploadActions.mteUploadSnapshotReceived()),
          timeout(7000),
          catchError(() => of(SpreadsheetUploadActions.mteUploadSnapshotError())),
          take(1)
        )
      )
    )
  )
